module.exports = __webpack_public_path__ + "img/543.49128978.png";